import React, { Suspense, useEffect } from 'react';
import { Loader } from 'ui/atoms';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { getData } from '../ducks/coins';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';

const mapStateToProps = state => ({
  coin: getData(state)
})

export default (Component, i18nTitle) => {
  const SuspenseEnhancer = ({ coin, match, history, location, ...props }) => {
    const name = coin?.name || '';
    const type = (coin?.type || '').toUpperCase();
    const coinName = `${name} ${type}`;
    const matchMinerAddress = match?.params?.id || '';
    const matchCoinSlug = match?.params?.slug || '';

    const { t, i18n } = useTranslation();
    useEffect(() => {
      if (!i18nTitle || !match.isExact) {
        return;
      }
      let titleText = t(i18nTitle);
      if (!titleText) {
        return;
      }
      if (coinName && matchCoinSlug) {
        titleText = titleText.replaceAll('#coin#', coinName);
      }
      if (matchMinerAddress) {
        titleText = titleText.replaceAll('#miner#', matchMinerAddress);
      }
      document.title = titleText;
      // Disabled due to warning about exhaustive-deps,
      // because t var will never change with lang, but i18n.language will.
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [i18n.language, coinName, matchCoinSlug, matchMinerAddress, match.isExact]);

    return (
      <Suspense fallback={<Loader />}>
        <Component {...props} />
      </Suspense>
    );
  }

  return compose(
    withRouter,
    connect(mapStateToProps),
  )(SuspenseEnhancer);
}

